import React, { Component } from 'react';
import { withOktaAuth } from '@okta/okta-react';
import { Link } from 'react-router-dom';
import config from './config';
import { BUs } from './Utils/BU.js';
import Alert from './components/Alert';
import { FormattedMessage } from 'react-intl';

export default withOktaAuth(class Settings extends Component {
  constructor() {
    super();
    this.state = {
      userinfo: null,
      admins: [],
      editableFields: [
        "primaryPhone",
        "mobilePhone",
        "C_facsimileTelephoneNumber",
        "C_ipPhone",
        "C_countryname",
        "city",
        "zipCode",
        "streetAddress",
        "C_houseIdentifier",
        "C_physicalDeliveryOfficeName",
        "preferredLanguage",
        "C_assistant",
        "linkedInURI",
        "xURI"
      ],
      domains: [],
      organizations: [],
      addresses: [],
      isAdmin: false,
      selectedMenu: '',
      selectedAction: '',
      form: {},
      ready: false,
      bus: BUs,
      alert: null
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.form = React.createRef();
  }

  async componentDidMount() {
    this.initializeSettings();
  }

  async componentWillUnmount() {
  }

  showAlert(type, title, message) {
    this.setState({
      alert: { type, title, message }
    });
    // Auto-hide alert after 5 seconds
    setTimeout(() => {
      this.setState({ alert: null });
    }, 5000);
  }

  hideAlert() {
    this.setState({ alert: null });
  }

  async actionSelected(target, action) {
    this.setState({
      ready: false,
      selectedMenu: target,
      selectedAction: action,
      form: {}
    }, async () => {
      try {
        if (!this.props.authState?.accessToken?.accessToken) { this.setState({ ready: true }); return; }
        let accessToken = this.props.authState.accessToken.accessToken;
        if (target === 'domains' || target === 'organizations') {
          this.setState({
            form: {
              primaryPhone: true,
              mobilePhone: true,
              C_ipPhone: true,
              C_facsimileTelephoneNumber: true,
              C_assistant: true,
              C_physicalDeliveryOfficeName: true,
              C_houseIdentifier: true,
              preferredLanguage: true,
              streetAddress: true,
              city: true,
              C_countryname: true,
              zipCode: true,
              xURI: true,
              linkedInURI: true
            }
          })
        }
        if (target === 'addresses' && action === 'change') {
          let res = await fetch(config.env.resourceServer.admin.buAddresses, {
            headers: {
              Authorization: `Bearer ${accessToken}`
            },
          });
          let addresses = await res.json();
          this.setState({
            addresses: addresses,
          });
        }
        if (target === 'domains' && action === 'change') {
          this.getDomains();
        }
        if (target === 'organizations' && action === 'change') {
          this.getOrganizations();
        }
        if (target === 'admins' && action === 'change') {
          let res = await fetch(config.env.resourceServer.admin.users, {
            headers: {
              Authorization: `Bearer ${accessToken}`
            },
          });
          let admins = await res.json();
          this.setState({
            admins: admins,
            ready: true
          });
        }
        window.scrollTo(0, this.form.current.offsetTop);
      } catch (err) {
        console.error(err);
      }
      this.setState({ ready: true });
    });
  }

  async initializeSettings() {
    if (!this.props.authState || !this.props.authState.isAuthenticated) return;
    if (!this.props.authState?.accessToken?.accessToken) return;
    try {
      const _user = await this.props.oktaAuth.getUser();
      this.setState({ userinfo: _user }, async () => {
        try {
          const accessToken = this.props.authState.accessToken.accessToken;
          let res = await fetch(config.env.resourceServer.admin.users, {
            headers: {
              Authorization: `Bearer ${accessToken}`
            },
          });
          let admins = await res.json();
          this.setState({
            admins: admins,
            ready: true,
            isAdmin: admins.some(x => x.toUpperCase() === _user.preferred_username.toUpperCase())
          });
        } catch (innerErr) {
          console.error(innerErr);
          this.setState({ ready: true });
        }
      });
    } catch (err) {
      console.error('[Settings] initializeSettings error', err);
      this.setState({ ready: true });
    }
  }

  async getDomains() {
    try {
      let accessToken = this.props.authState.accessToken.accessToken;
      let res = await fetch(config.env.resourceServer.admin.selfServiceDomains, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
      });
      let domains = await res.json();
      this.setState({
        domains: domains,
      });
    } catch (error) {
      console.error(error);
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    let form = this.state.form;
    form[name] = value;
    this.setState({
      form: form
    });
  }

  async removeAdmin(upn) {
    this.setState({ ready: false });
    try {
      let accessToken = this.props.authState.accessToken.accessToken;
      await fetch(`${config.env.resourceServer.admin.users}/${upn}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });

      let index = this.state.admins.indexOf(upn);
      let admins = this.state.admins;
      admins.splice(index, 1);
      this.setState({ admins: admins, ready: true });
    } catch (err) {
      this.setState({ ready: true });
      console.error(err);
    }
  }

  async addAdmin() {
    this.setState({ ready: false });
    try {
      let accessToken = this.props.authState.accessToken.accessToken;
      await fetch(config.env.resourceServer.admin.users, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userLogin: this.state.form.groupId + "@" + config.env.domain
        })
      });
    } catch (err) {
      console.error(err);
    }
    this.setState({
      ready: true,
      form: {}
    });
  }

  async addAddresses() {
    this.setState({ ready: false });
    try {
      let accessToken = this.props.authState.accessToken.accessToken;
      await fetch(config.env.resourceServer.admin.buAddresses, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: this.state.json
      });

    } catch (err) {
      console.error(err);
    }
    this.setState({
      ready: true,
      form: {}
    });
  }

  async removeAllBUAddresses(bu) {
    this.setState({ ready: false });
    try {
      let accessToken = this.props.authState.accessToken.accessToken;
      await fetch(`${config.env.resourceServer.admin.buAddresses}/${bu}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });

      let index = this.state.addresses.findIndex(a => a.bu === bu);
      let addresses = this.state.addresses;
      addresses.splice(index, 1);
      this.setState({ addresses: addresses, ready: true });
    } catch (err) {
      this.setState({ ready: true });
      console.error(err);
    }
  }

  async removeDomain(domain) {
    this.setState({ ready: false });
    try {
      let accessToken = this.props.authState.accessToken.accessToken;
      await fetch(`${config.env.resourceServer.admin.selfServiceDomains}/${domain}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });

      let index = this.state.domains.findIndex(d => d.id === domain);
      let domains = this.state.domains;
      domains.splice(index, 1);
      this.setState({ domains: domains, ready: true });
    } catch (err) {
      this.setState({ ready: true });
      console.error(err);
    }
  }

  async addDomain() {
    this.setState({ ready: false });
    try {
      let accessToken = this.props.authState.accessToken.accessToken;
      await fetch(config.env.resourceServer.admin.selfServiceDomains, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.state.form)
      });
    } catch (err) {
      console.error(err);
    }
    this.setState({
      ready: true,
      form: {}
    });
  }

  async updateDomain() {
    this.setState({ ready: false });
    try {
      let accessToken = this.props.authState.accessToken.accessToken;
      await fetch(config.env.resourceServer.admin.selfServiceDomains, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.state.form)
      });
      await this.getDomains();
    } catch (err) {
      console.error(err);
    }
    this.setState({
      ready: true,
      form: {}
    });
  }

  async editDomainSelected(domain) {
    if (this.state.form.domain !== domain) {
      let element = this.state.domains.find(d => d.id === domain);
      this.setState({
        form: {
          domain: domain,
          primaryPhone: element.allowedAttributes.indexOf("primaryPhone") !== -1,
          mobilePhone: element.allowedAttributes.indexOf("mobilePhone") !== -1,
          C_ipPhone: element.allowedAttributes.indexOf("C_ipPhone") !== -1,
          C_facsimileTelephoneNumber: element.allowedAttributes.indexOf("C_facsimileTelephoneNumber") !== -1,
          C_assistant: element.allowedAttributes.indexOf("C_assistant") !== -1,
          C_physicalDeliveryOfficeName: element.allowedAttributes.indexOf("C_physicalDeliveryOfficeName") !== -1,
          C_houseIdentifier: element.allowedAttributes.indexOf("C_houseIdentifier") !== -1,
          preferredLanguage: element.allowedAttributes.indexOf("preferredLanguage") !== -1,
          streetAddress: element.allowedAttributes.indexOf("streetAddress") !== -1,
          city: element.allowedAttributes.indexOf("city") !== -1,
          C_countryname: element.allowedAttributes.indexOf("C_countryname") !== -1,
          zipCode: element.allowedAttributes.indexOf("zipCode") !== -1,
          xURI: element.allowedAttributes.indexOf("xURI") !== -1,
          linkedInURI: element.allowedAttributes.indexOf("linkedInURI") !== -1
        }
      });
    } else {
      this.setState({
        form: {}
      });
    }
  }

  async getOrganizations() {
    try {
      let accessToken = this.props.authState.accessToken.accessToken;
      let res = await fetch(config.env.resourceServer.admin.selfServiceOrganizations, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
      });
      let organizations = await res.json();
      this.setState({
        organizations: organizations,
      });
    } catch (error) {
      console.error(error);
    }
  }

  async removeOrganization(organization) {
    this.setState({ ready: false });
    try {
      let accessToken = this.props.authState.accessToken.accessToken;
      await fetch(`${config.env.resourceServer.admin.selfServiceOrganizations}/${organization}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });

      let index = this.state.organizations.findIndex(o => o.id === organization);
      let organizations = this.state.organizations;
      organizations.splice(index, 1);
      this.setState({ organizations: organizations, ready: true });
    } catch (err) {
      this.setState({ ready: true });
      console.error(err);
    }
  }

  async addOrganization() {
    this.setState({ ready: false });
    try {
      let accessToken = this.props.authState.accessToken.accessToken;
      await fetch(config.env.resourceServer.admin.selfServiceOrganizations, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.state.form)
      });
    } catch (err) {
      console.error(err);
    }
    this.setState({
      form: {},
      ready: true
    });
  }

  async updateOrganization() {
    this.setState({ ready: false });
    try {
      let accessToken = this.props.authState.accessToken.accessToken;
      await fetch(config.env.resourceServer.admin.selfServiceOrganizations, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.state.form)
      });
      await this.getOrganizations();
    } catch (err) {
      console.error(err);
    }
    this.setState({
      ready: true,
      form: {}
    });
  }

  async editOrganizationSelected(organization) {
    if (this.state.form.organization !== organization) {
      let element = this.state.organizations.find(o => o.id === organization);
      this.setState({
        form: {
          organization: organization,
          primaryPhone: element.allowedAttributes.indexOf("primaryPhone") !== -1,
          mobilePhone: element.allowedAttributes.indexOf("mobilePhone") !== -1,
          C_ipPhone: element.allowedAttributes.indexOf("C_ipPhone") !== -1,
          C_facsimileTelephoneNumber: element.allowedAttributes.indexOf("C_facsimileTelephoneNumber") !== -1,
          C_assistant: element.allowedAttributes.indexOf("C_assistant") !== -1,
          C_physicalDeliveryOfficeName: element.allowedAttributes.indexOf("C_physicalDeliveryOfficeName") !== -1,
          C_houseIdentifier: element.allowedAttributes.indexOf("C_houseIdentifier") !== -1,
          preferredLanguage: element.allowedAttributes.indexOf("preferredLanguage") !== -1,
          streetAddress: element.allowedAttributes.indexOf("streetAddress") !== -1,
          city: element.allowedAttributes.indexOf("city") !== -1,
          C_countryname: element.allowedAttributes.indexOf("C_countryname") !== -1,
          zipCode: element.allowedAttributes.indexOf("zipCode") !== -1,
          xURI: element.allowedAttributes.indexOf("xURI") !== -1,
          linkedInURI: element.allowedAttributes.indexOf("linkedInURI") !== -1
        }
      });
    } else {
      this.setState({
        form: {}
      });
    }

  }

  async editBUAddressesSelected(bu) {
    if (this.state.form.bu !== bu) {
      this.setState({
        form: {
          bu: bu
        }
      });
    } else {
      this.setState({
        form: {}
      });
    }
  }

  async updateAddresses() {
    this.setState({ ready: false });
    try {
      let json = JSON.parse(this.state.json);
      if (json.bu !== this.state.form.bu) {
        throw new Error(`BU name ${this.state.form.bu} doesn't correspond to json ${json.bu}`);
      }
      let accessToken = this.props.authState.accessToken.accessToken;
      await fetch(config.env.resourceServer.admin.buAddresses, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: this.state.json
      });
    } catch (err) {
      console.error(err);
    }
    this.setState({
      form: {},
      ready: true
    });
  }

  async handleFile(e) {
    let form = this.state.form;
    let res = JSON.parse(e.target.result);
    form["addressesCount"] = res.allowedAddresses.length;
    this.setState({
      json: e.target.result,
      form: form
    });
  }

  async onChangeFile(event) {
    if (event.target.files.length > 0) {
      event.stopPropagation();
      event.preventDefault();
      if (event.target.files[0].type !== 'application/json') {
        alert("The selected file is not a json file.");
        return
      }
      var reader = new FileReader();
      reader.onloadend = this.handleFile;
      reader.readAsText(event.target.files[0]);
      let form = this.state.form;
      form["fileName"] = event.target.files[0].name;
    }
  }

  handleSubmit() {
    console.log(this.state.form);
  }

  download(bu) {
    let element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify(this.state.addresses.find(x => x.bu === bu))));
    element.setAttribute('download', `${bu}.json`);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  render() {
    return (
      <div className="page-container">
        {/* Alert Display */}
        {this.state.alert && (
          <div className="alert-container">
            <Alert
              type={this.state.alert.type}
              title={this.state.alert.title}
              message={this.state.alert.message}
              onClose={() => this.hideAlert()}
            />
          </div>
        )}
        
        {/* Loading State */}
        {!this.state.ready && (
          <div className="page-loading">
            <div className="loading-spinner"></div>
            <p className="loading-text"><FormattedMessage id="settings.loading" defaultMessage="Loading settings..." /></p>
          </div>
        )}

        {/* Hero Section */}
        {this.state.ready && (
          <section className="hero-section bg-light page-inner">
            <div className="overlay engiegradient-background"></div>
            <div className="hero-banner-wrapper">
              <div className="container">
                <div className="row">
                  <div className="col-md-8 breadcrumb-col">
                    <div className="page-title no-bottom-space">
                      <nav className="breadcrumb-wrapper compact">
                        <div className="breadcrumb-modern compact breadcrumb-flex-center">
                          <Link to="/" className="breadcrumb-link breadcrumb-item"><FormattedMessage id="breadcrumb.home" defaultMessage="Home" /></Link>
                          <span className="breadcrumb-separator">/</span>
                          <span className="breadcrumb-item breadcrumb-current"><FormattedMessage id="breadcrumb.settings" defaultMessage="Settings" /></span>
                        </div>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {this.state.ready && (
          <div className="container mt-4">
            {/* Admin Dashboard */}
            {this.state.isAdmin && this.state.ready && (
              <div className="settings-dashboard">
                <div className="settings-section">
                  <div className="settings-section-header">
                    <h2><FormattedMessage id="settings.administration" defaultMessage="Administration" /></h2>
                    <p><FormattedMessage id="settings.administrationDescription" defaultMessage="Manage system administrators and core configurations" /></p>
                  </div>
                  <div className="settings-items">
                    <div className="settings-grid">
                      <div className="settings-item">
                        <div className="settings-item-content">
                          <h3 className="settings-item-title"><FormattedMessage id="settings.adminManagement" defaultMessage="Administrator Management" /></h3>
                          <p className="settings-item-description"><FormattedMessage id="settings.adminManagementDescription" defaultMessage="Add or remove system administrators and configure permissions" /></p>
                        </div>
                        <div className="settings-item-actions">
                          <button
                            className="settings-action-btn primary"
                            title="Add administrator"
                            onClick={() => this.actionSelected('admins', 'add')}
                          >
                            <i className="fa-solid fa-plus"></i>
                          </button>
                          <button
                            className="settings-action-btn secondary"
                            title="Manage administrators"
                            onClick={() => this.actionSelected('admins', 'change')}
                          >
                            <i className="fa-solid fa-users-gear"></i>
                          </button>
                        </div>
                      </div>

                      <div className="settings-item">
                        <div className="settings-item-content">
                          <h3 className="settings-item-title"><FormattedMessage id="settings.orgManagement" defaultMessage="Organization Management" /></h3>
                          <p className="settings-item-description"><FormattedMessage id="settings.orgManagementDescription" defaultMessage="Configure organizational units and their editable profile attributes" /></p>
                        </div>
                        <div className="settings-item-actions">
                          <button
                            className="settings-action-btn primary"
                            title="Add organization"
                            onClick={() => this.actionSelected('organizations', 'add')}
                          >
                            <i className="fa-solid fa-plus"></i>
                          </button>
                          <button
                            className="settings-action-btn secondary"
                            title="Manage organizations"
                            onClick={() => this.actionSelected('organizations', 'change')}
                          >
                            <i className="fa-solid fa-building"></i>
                          </button>
                        </div>
                      </div>

                      <div className="settings-item">
                        <div className="settings-item-content">
                          <h3 className="settings-item-title"><FormattedMessage id="settings.domainConfig" defaultMessage="Domain Configuration" /></h3>
                          <p className="settings-item-description"><FormattedMessage id="settings.domainConfigDescription" defaultMessage="Manage domain configurations and specify allowed profile fields" /></p>
                        </div>
                        <div className="settings-item-actions">
                          <button
                            className="settings-action-btn primary"
                            title="Add domain"
                            onClick={() => this.actionSelected('domains', 'add')}
                          >
                            <i className="fa-solid fa-plus"></i>
                          </button>
                          <button
                            className="settings-action-btn secondary"
                            title="Manage domains"
                            onClick={() => this.actionSelected('domains', 'change')}
                          >
                            <i className="fa-solid fa-gear"></i>
                          </button>
                        </div>
                      </div>

                      <div className="settings-item">
                        <div className="settings-item-content">
                          <h3 className="settings-item-title"><FormattedMessage id="settings.addressManagement" defaultMessage="Address Management" /></h3>
                          <p className="settings-item-description"><FormattedMessage id="settings.addressManagementDescription" defaultMessage="Configure business unit addresses and location data for the directory" /></p>
                        </div>
                        <div className="settings-item-actions">
                          <button
                            className="settings-action-btn primary"
                            title="Import addresses"
                            onClick={() => this.actionSelected('addresses', 'add')}
                          >
                            <i className="fa-solid fa-upload"></i>
                          </button>
                          <button
                            className="settings-action-btn secondary"
                            title="Manage addresses"
                            onClick={() => this.actionSelected('addresses', 'change')}
                          >
                            <i className="fa-solid fa-location-dot"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Settings Forms */}
            <div ref={this.form}>
              {this.renderSelectedForm()}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderSelectedForm() {
    const { selectedMenu, selectedAction, form, admins, domains, organizations, addresses, ready } = this.state;

    if (!selectedMenu) {
      return null;
    }

    return (
      <div className="settings-form-section">
        <div className="settings-form-card">
          {/* Admin Management Forms */}
          {selectedMenu === 'admins' && selectedAction === 'add' && (
            <div className="form-container">
              <div className="form-header">
                <h3 className="form-title"><FormattedMessage id="settings.addAdmin" defaultMessage="Add Administrator" /></h3>
                <p className="form-description"><FormattedMessage id="settings.addAdminDescription" defaultMessage="Add a new system administrator by providing their Group ID" /></p>
              </div>
              <form className="modern-form">
                <div className="form-group">
                  <label htmlFor="groupId" className="form-label"><FormattedMessage id="field.groupid" defaultMessage="Group ID" /></label>
                  <FormattedMessage id="placeholder.groupId" defaultMessage="Enter user group ID (without domain)">
                    {(placeholder) => (
                      <input
                        type="text"
                        id="groupId"
                        name="groupId"
                        value={form.groupId || ''}
                        onChange={this.handleInputChange}
                        className="form-input"
                        placeholder={placeholder}
                      />
                    )}
                  </FormattedMessage>
                  <small className="form-help">Domain @{config.env.domain} will be added automatically</small>
                </div>
                <div className="form-actions">
                  <button type="button" onClick={() => this.addAdmin()} className="btn btn-primary">
                    <i className="fa-solid fa-plus"></i>
                    <FormattedMessage id="settings.addAdmin" defaultMessage="Add Administrator" />
                  </button>
                </div>
              </form>
            </div>
          )}

          {selectedMenu === 'admins' && selectedAction === 'change' && (
            <div className="form-container">
              <div className="form-header">
                <h3 className="form-title"><FormattedMessage id="settings.currentAdmins" defaultMessage="Current Administrators" /></h3>
                <p className="form-description"><FormattedMessage id="settings.currentAdminsDescription" defaultMessage="Manage existing system administrators" /></p>
              </div>
              <div className="admin-list">
                {admins.map((admin, index) => (
                  <div key={index} className="admin-item">
                    <div className="admin-info">
                      <i className="fa-solid fa-user-shield admin-icon"></i>
                      <span className="admin-name">{admin}</span>
                    </div>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => this.removeAdmin(admin)}
                      title="Remove administrator"
                    >
                      <i className="fa-solid fa-trash"></i>
                      Remove
                    </button>
                  </div>
                ))}
                {admins.length === 0 && (
                  <div className="empty-state">
                    <i className="fa-solid fa-users-slash"></i>
                    <p><FormattedMessage id="settings.noAdmins" defaultMessage="No administrators found" /></p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Domain Management Forms */}
          {selectedMenu === 'domains' && selectedAction === 'add' && (
            <div className="form-container">
              <div className="form-header">
                <h3 className="form-title"><FormattedMessage id="settings.addDomain" defaultMessage="Add Domain Configuration" /></h3>
                <p className="form-description"><FormattedMessage id="settings.addDomainDescription" defaultMessage="Create a new domain configuration with allowed profile fields" /></p>
              </div>
              <form className="modern-form">
                <div className="form-group">
                  <label htmlFor="domain" className="form-label"><FormattedMessage id="settings.domainName" defaultMessage="Domain Name" /></label>
                  <FormattedMessage id="placeholder.domainName" defaultMessage="Enter domain name">
                    {(placeholder) => (
                      <input
                        type="text"
                        id="domain"
                        name="domain"
                        value={form.domain || ''}
                        onChange={this.handleInputChange}
                        className="form-input"
                        placeholder={placeholder}
                      />
                    )}
                  </FormattedMessage>
                </div>

                <div className="form-group">
                  <label className="form-label"><FormattedMessage id="settings.allowedFields" defaultMessage="Allowed Profile Fields" /></label>
                  <p className="form-description"><FormattedMessage id="settings.allowedFieldsDescription" defaultMessage="Select which fields can be edited by users in this domain" /></p>
                  <div className="checkbox-grid">
                    {this.state.editableFields.map(field => (
                      <div key={field} className="custom-checkbox">
                        <input
                          type="checkbox"
                          id={`domain-${field}`}
                          name={field}
                          checked={form[field] || false}
                          onChange={this.handleInputChange}
                        />
                        <label htmlFor={`domain-${field}`} className="checkbox-label">{field}</label>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="form-actions">
                  <button type="button" onClick={() => this.addDomain()} className="btn btn-primary">
                    <i className="fa-solid fa-plus"></i>
                    Add Domain
                  </button>
                </div>
              </form>
            </div>
          )}

          {selectedMenu === 'domains' && selectedAction === 'change' && (
            <div className="form-container">
              <div className="form-header">
                <h3 className="form-title"><FormattedMessage id="settings.domainConfigs" defaultMessage="Domain Configurations" /></h3>
                <p className="form-description"><FormattedMessage id="settings.domainConfigsDescription" defaultMessage="Manage existing domain configurations" /></p>
              </div>
              <div className="domain-list">
                {domains.map((domain, index) => (
                  <div key={index} className="domain-item">
                    <div className="domain-header" onClick={() => this.editDomainSelected(domain.id)}>
                      <div className="domain-info">
                        <i className="fa-solid fa-globe domain-icon"></i>
                        <div>
                          <span className="domain-name">{domain.id}</span>
                          <span className="domain-count">{domain.allowedAttributes.length} fields allowed</span>
                        </div>
                      </div>
                      <div className="domain-actions">
                        <button
                          className="btn-icon danger"
                          onClick={(e) => { e.stopPropagation(); this.removeDomain(domain.id); }}
                          title="Remove domain"
                        >
                          <i className="fa-solid fa-trash"></i>
                        </button>
                      </div>
                    </div>

                    {form.domain === domain.id && (
                      <div className="domain-edit-form">
                        <div className="form-group">
                          <label className="form-label">Allowed Profile Fields</label>
                          <div className="checkbox-grid">
                            {this.state.editableFields.map(field => (
                              <div key={field} className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  id={`edit-${domain.id}-${field}`}
                                  name={field}
                                  checked={form[field] || false}
                                  onChange={this.handleInputChange}
                                />
                                <label htmlFor={`edit-${domain.id}-${field}`} className="checkbox-label">{field}</label>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="form-actions">
                          <button type="button" onClick={() => this.updateDomain()} className="btn btn-primary">
                            <i className="fa-solid fa-save"></i>
                            Update Domain
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
                {domains.length === 0 && (
                  <div className="empty-state">
                    <i className="fa-solid fa-globe"></i>
                    <p><FormattedMessage id="settings.noDomains" defaultMessage="No domains configured" /></p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Organization Management */}
          {selectedMenu === 'organizations' && selectedAction === 'add' && (
            <div className="form-container">
              <div className="form-header">
                <h3 className="form-title"><FormattedMessage id="settings.addOrg" defaultMessage="Add Organization" /></h3>
                <p className="form-description"><FormattedMessage id="settings.addOrgDescription" defaultMessage="Create a new organization configuration" /></p>
              </div>
              <form className="modern-form">
                <div className="form-group">
                  <label htmlFor="organization" className="form-label"><FormattedMessage id="settings.orgId" defaultMessage="Organization ID" /></label>
                  <FormattedMessage id="placeholder.orgId" defaultMessage="Enter organization ID">
                    {(placeholder) => (
                      <input
                        type="text"
                        id="organization"
                        name="organization"
                        value={form.organization || ''}
                        onChange={this.handleInputChange}
                        className="form-input"
                        placeholder={placeholder}
                      />
                    )}
                  </FormattedMessage>
                </div>

                <div className="form-group">
                  <label className="form-label">Allowed Profile Fields</label>
                  <div className="checkbox-grid">
                    {this.state.editableFields.map(field => (
                      <div key={field} className="custom-checkbox">
                        <input
                          type="checkbox"
                          id={`org-${field}`}
                          name={field}
                          checked={form[field] || false}
                          onChange={this.handleInputChange}
                        />
                        <label htmlFor={`org-${field}`} className="checkbox-label">{field}</label>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="form-actions">
                  <button type="button" onClick={() => this.addOrganization()} className="btn btn-primary">
                    <i className="fa-solid fa-plus"></i>
                    Add Organization
                  </button>
                </div>
              </form>
            </div>
          )}

          {selectedMenu === 'organizations' && selectedAction === 'change' && (
            <div className="form-container">
              <div className="form-header">
                <h3 className="form-title"><FormattedMessage id="settings.orgConfigs" defaultMessage="Organization Configurations" /></h3>
                <p className="form-description"><FormattedMessage id="settings.orgConfigsDescription" defaultMessage="Manage existing organization settings" /></p>
              </div>
              <div className="organization-list">
                {organizations.map((org, index) => (
                  <div key={index} className="organization-item">
                    <div className="organization-header" onClick={() => this.editOrganizationSelected(org.id)}>
                      <div className="organization-info">
                        <i className="fa-solid fa-building organization-icon"></i>
                        <div>
                          <span className="organization-name">{org.id}</span>
                          <span className="organization-count">{org.allowedAttributes.length} fields allowed</span>
                        </div>
                      </div>
                      <div className="organization-actions">
                        <button
                          className="btn-icon danger"
                          onClick={(e) => { e.stopPropagation(); this.removeOrganization(org.id); }}
                          title="Remove organization"
                        >
                          <i className="fa-solid fa-trash"></i>
                        </button>
                      </div>
                    </div>

                    {form.organization === org.id && (
                      <div className="organization-edit-form">
                        <div className="form-group">
                          <label className="form-label">Allowed Profile Fields</label>
                          <div className="checkbox-grid">
                            {this.state.editableFields.map(field => (
                              <div key={field} className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  id={`edit-org-${org.id}-${field}`}
                                  name={field}
                                  checked={form[field] || false}
                                  onChange={this.handleInputChange}
                                />
                                <label htmlFor={`edit-org-${org.id}-${field}`} className="checkbox-label">{field}</label>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="form-actions">
                          <button type="button" onClick={() => this.updateOrganization()} className="btn btn-primary">
                            <i className="fa-solid fa-save"></i>
                            Update Organization
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
                {organizations.length === 0 && (
                  <div className="empty-state">
                    <i className="fa-solid fa-building"></i>
                    <p><FormattedMessage id="settings.noOrgs" defaultMessage="No organizations configured" /></p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Address Management */}
          {selectedMenu === 'addresses' && selectedAction === 'add' && (
            <div className="form-container">
              <div className="form-header">
                <h3 className="form-title"><FormattedMessage id="settings.importAddresses" defaultMessage="Import Addresses" /></h3>
                <p className="form-description"><FormattedMessage id="settings.importAddressesDescription" defaultMessage="Upload a JSON file containing business unit addresses" /></p>
              </div>
              <div className="upload-form">
                <div className="upload-area" onClick={() => { this.upload.click() }}>
                  <i className="fa-solid fa-upload upload-icon"></i>
                  <h4><FormattedMessage id="settings.clickUpload" defaultMessage="Click to upload JSON file" /></h4>
                  <p><FormattedMessage id="settings.selectFile" defaultMessage="Select a JSON file containing address data" /></p>
                </div>
                <input
                  ref={(ref) => this.upload = ref}
                  type="file"
                  accept="application/json"
                  style={{ display: "none" }}
                  onChange={this.onChangeFile.bind(this)}
                />
                {form.fileName && (
                  <div className="upload-info">
                    <div className="upload-success">
                      <i className="fa-solid fa-check-circle"></i>
                      <div>
                        <strong>{form.fileName}</strong>
                        <p>{form.addressesCount} addresses found</p>
                      </div>
                    </div>
                    <div className="form-actions">
                      <button
                        type="button"
                        onClick={() => this.addAddresses()}
                        className={form.addressesCount ? "btn btn-primary" : "btn btn-disabled"}
                        disabled={!form.addressesCount}
                      >
                        <i className="fa-solid fa-upload"></i>
                        Import Addresses
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {selectedMenu === 'addresses' && selectedAction === 'change' && (
            <div className="form-container">
              <div className="form-header">
                <h3 className="form-title"><FormattedMessage id="settings.addressManagement" defaultMessage="Address Management" /></h3>
                <p className="form-description"><FormattedMessage id="settings.addressManagementDescription" defaultMessage="Manage business unit addresses" /></p>
              </div>
              <div className="address-list">
                {addresses.map((address, index) => (
                  <div key={index} className="address-item">
                    <div className="address-header" onClick={() => this.editBUAddressesSelected(address.bu)}>
                      <div className="address-info">
                        <i className="fa-solid fa-location-dot address-icon"></i>
                        <div>
                          <span className="address-name">{address.bu}</span>
                          <span className="address-count"><FormattedMessage id="settings.businessUnitAddresses" defaultMessage="Business Unit Addresses" /></span>
                        </div>
                      </div>
                      <div className="address-actions">
                        <button
                          className="btn-icon primary"
                          onClick={(e) => { e.stopPropagation(); this.download(address.bu); }}
                          title="Download addresses"
                        >
                          <i className="fa-solid fa-download"></i>
                        </button>
                        <button
                          className="btn-icon danger"
                          onClick={(e) => { e.stopPropagation(); this.removeAllBUAddresses(address.bu); }}
                          title="Remove all addresses"
                        >
                          <i className="fa-solid fa-trash"></i>
                        </button>
                      </div>
                    </div>

                    {form.bu === address.bu && (
                      <div className="address-edit-form">
                        <div className="upload-area small" onClick={() => { this.upload.click() }}>
                          <i className="fa-solid fa-upload mr-3"></i>
                          <span><FormattedMessage id="settings.uploadNewFile" defaultMessage="Upload new addresses file" /></span>
                        </div>
                        <input
                          ref={(ref) => this.upload = ref}
                          type="file"
                          accept="application/json"
                          style={{ display: "none" }}
                          onChange={this.onChangeFile.bind(this)}
                        />
                        {form.fileName && (
                          <div className="upload-info">
                            <div className="upload-success">
                              <i className="fa-solid fa-check-circle"></i>
                              <div>
                                <strong>{form.fileName}</strong>
                                <p>{form.addressesCount} addresses found</p>
                              </div>
                            </div>
                            <div className="form-actions">
                              <button
                                type="button"
                                onClick={() => this.updateAddresses()}
                                className={form.addressesCount > 0 ? "btn btn-primary" : "btn btn-disabled"}
                                disabled={!form.addressesCount || form.addressesCount === 0}
                              >
                                <i className="fa-solid fa-save"></i>
                                Update Addresses
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ))}
                {addresses.length === 0 && (
                  <div className="empty-state">
                    <i className="fa-solid fa-location-dot"></i>
                    <p><FormattedMessage id="settings.noAddresses" defaultMessage="No addresses configured" /></p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
});
